import { network } from 'services/network';
import { useQuery } from 'react-query';
import { IFilterValue } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReportTypes';
import { orderBy } from 'lodash';
import { FilterNames } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';
import { QueryKeys } from 'api/queryKeys';
import qs from 'qs';

const queryFn = () => {
    const querystring = qs.stringify(
        { ApplicationComponentType: 'KEY_ACHIEVEMENT' },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getFilterByComponent${querystring}`;
    return network.get(url).then((response) => orderBy(response.data, ['order', 'asc']));
};

export const useQueryGetAchievementsFilters = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], QueryKeys>({
        queryKey: 'AchievementsFilters',
        queryFn,
    });
};

export interface QueryResponse {
    title: string;
    filterValues: IFilterValue[];
    filterName?: keyof typeof FilterNames;
}
